import { useState, useEffect } from "react";
import { swing } from "../../util/icon";
import { useDispatch, useSelector } from "react-redux";
import { getNewStatusFetch } from "../../features/action/fetchStatus";
import { search, sortDate } from "../../util/sort";
import { OrderHeader } from "./OrderHeader";
import { useSearch } from "../../context/SearchContext";
import { Button, DateBLock, MembersBlock } from "./main";
import { Disigner } from "./Disigner";
import { putUpdateSewnFileFetch } from "../../features/action/fetchPrint";

const Sewing = () => {
  const { manager } = useSelector((state) => state.status);
  const dispatch = useDispatch();
  const [filteredStatus, setFilteredStatus] = useState([]);
  const [number, setNumber] = useState(null);
  const [lines, setLines] = useState({});
  const [workers, setWorkers] = useState({});

  const setLineForOrder = (orderId, line) => {
    setLines((prev) => ({
      ...prev,
      [orderId]: line,
    }));
  };

  const setWorkersForOrder = (orderId, workersList) => {
    setWorkers((prev) => ({
      ...prev,
      [orderId]: workersList,
    }));
  };
  const { searchQuery } = useSearch();

  // Сортировка по дате завершения
  const handleToDate = () => {
    const sortedStatus = sortDate([...manager], "toDate");
    setFilteredStatus(sortedStatus);
  };
  // Обработчик отправки
  const handleClickSewn = (id) => {
    console.log("workers:", workers[id], "line:", lines[id], "number:", number);
    dispatch(putUpdateSewnFileFetch(id, workers[id], lines[id], number));
  };

  useEffect(() => {
    dispatch(getNewStatusFetch());
  }, [dispatch]);

  useEffect(() => {
    const filteredResults = searchQuery
      ? search(manager, searchQuery)
      : manager;
    setFilteredStatus(filteredResults);
  }, [searchQuery, manager]);

  return (
    <div className="w-[100%]">
      <div className="flex flex-col  mx-auto">
        {/* Заголовки */}
        <OrderHeader onToDateClick={handleToDate}/>
        <div className="rounded-xl mb-6">
          {filteredStatus.map(
            (i) =>
              i.studio.sewing && (
                <div
                  key={i._id}
                  className="flex flex-row h-[64px] mb-1 text-center rounded-[10px] bg-white border-solid border-[1px] border-[#dbdbdb]"
                >
                  {DateBLock(i.toDate, i.fromDate)}
                  {MembersBlock(i.manager, i.designer)}
                  {/* ----------------------------------------Block Number Order----------------------------------------------------- */}
                  {
                    <Disigner
                      i={i}
                      setNumber={setNumber}
                      setWorkers={(w) => setWorkersForOrder(i._id, w)}
                      setLine={(l) => setLineForOrder(i._id, l)}
                    />
                  }
                  {/* ---------------------------------------Button End-------------------------------------------------- */}
                  {Button(swing, () => handleClickSewn(i._id))}
                </div>
              )
          )}
        </div>
      </div>
    </div>
  );
};

export default Sewing;
